<template>
  <b-row class="overflow myModal">
    <b-overlay 
      :show="show"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small        
    >
      <!-- MOBILE -->
      <div class="mobile">
        <div class="link">
          <button class="bt btn-back" @click="closeModal">
            <font-awesome-icon :icon="['far', 'times']"/>
          </button>
          <h3>Jeu concours</h3>
        </div>
        <div class="sep"></div>       
      </div>
      <!-- MOBILE -->

      <!-- CONTENT SCROLLABLE-->
      <div class="scrollable block__laws">
      
          <Stack></Stack>
          <div v-if="infos.target && infos.target === 'progress'" class="target green">{{general.targetNew}}</div>
          <div v-if="infos.target && infos.target === 'done'" class="target done">{{general.targetDone}}</div>
          <div v-if="infos.target && infos.target === 'todo'" class="target red">{{general.targetTodo}}</div>

          <Stack height="0.5rem"></Stack>
          <h1>{{infos.modalTitleen}}</h1>
          <Stack></Stack>
          <div class="container-img" :style="{'background-image': `url(${theMedia})`}">
          <div class="loadImg" :class="{hidden:hide}" :style="{'background-color': '#E1E5E8'}">
            <div class="img-logo">
              <img src="/img/logo-areas-B&W.png" height="100px" width="100px">
            </div>
          </div>

            <!-- <b-img src="/img/adobestock-92030325-1-1-1280x800.png"></b-img> -->
            <div class="desc">
              <div class="texte">
              <p class="title">{{infos.accroche}}</p>
              <p class="subtitle">DU {{ infos.startDate | moment(true) }} AU {{ infos.startDate | moment(true) }}</p>
              </div>
            </div>

          </div>
          <Stack></Stack>
          <div class="desc">
            <div v-html="infos.message"></div>
            <Stack></Stack>

            <b-form-checkbox
              id="acceptedLaws"
              v-model="status"
              name="acceptedLaws"
              :value="accepted"
              unchecked-value="not_accepted"
              :class="{error:notAccepted}"
            >
              J’ai pris connaissance du <a :href="theLawLink" target="_blank"><u>règlement du concours</u></a>
            </b-form-checkbox>


            <Stack></Stack>

            <b-button class="bt btn-laws" @click="acceptedAndClose">
              <div class="left">
                <font-awesome-icon :icon="['fas','trophy']" />
                <p>{{general.lawsStart}}</p>
              </div>
              <font-awesome-icon :icon="['fas','chevron-right']" />
            </b-button>
            <Stack></Stack>

          </div>
      </div>
      <!-- CONTENT SCROLLABLE-->

    </b-overlay>
  </b-row>
</template>


<script>
import { mapGetters } from 'vuex'
import Stack from '../../../../components/module/stack/Stack';
import ApiService from '../../../../services/ApiService'
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'
import moment from 'moment'
moment.locale('fr');


export default {
  name:"challengesLaws",
    components:{
      Stack
    }, 
    computed: {
      ...mapGetters([
        'getBrowse',
        'getGeneral',
        'getChallengeSelected',
          'getIsMobile'
      ])
    },
    data () {
      return {
        content:"",
        infos:"",
        formContent:"",
        general:'',
        accepted:"accepted",
        isMobile:false,
        status: 'not_accepted',
        notAccepted:false,
        show:true,
        theLawLink:'',
        item:{
          src:'/img/loader.png',
        },
        theMedia:'',
        hide:false,
        isImageLoading: true
      }
    },
    mounted(){
      this.getData();
    },
    created (){
      this.content = this.getBrowse;
      this.general = this.getGeneral;
      this.isMobile = this.getIsMobile;
    },
    methods : {
      async getData(){
        if(this.getChallengeSelected){
          this.show = true;
          this.infos = await ApiService.getConcoursApi().getHomeFirstModal(ApiAuthenticationService.getCurrentUser().id,this.getChallengeSelected);
          this.infos = this.infos.data;
          if (this.infos.reglement){
            this.theLawLink =  this.infos.reglement.id ? await ApiService.getMediaApi().get(this.infos.reglement.id): '';
          } else {
            this.theLawLink = null;
          }
          if (this.infos.image){
            this.theMedia = this.infos.image.id ? await ApiService.getMediaApi().get(this.infos.image.id) : '';
            this.isImageLoading = false;
            this.hide = true;
          } else {
            this.theMedia = null;
            this.isImageLoading = false;
          }
          this.show = false;
        }        
      },
      goBack() {
        this.$store.dispatch('goBack');
        this.isMobile ? this.$store.dispatch('showHeader',true) : '';
        this.$router.push({name: "challengesHome"});
      }, 
      acceptedAndClose(){
        if(this.status == "accepted") {
            ApiService.getProfilApi().setAcceptModal(this.getChallengeSelected);
            //
            this.$emit('modalaccepted')
            this.notAccepted = false;
            this.isMobile ? this.$store.dispatch('showHeader',true) : '';
            //
          }else{
            this.notAccepted = true;
        } 
      },
      closeModal(){
          this.$emit('modalaccepted');
          this.isMobile ? this.$store.dispatch('showHeader',true) : '';
      }, 
      moment: function (date,year) {
        return moment(date,year).toUpperCase();
      },            
    },
    filters: {
      moment: function (date,year) {
        let $format = !year ? 'Do MMMM': 'Do MMMM YYYY';
        return moment(date).format($format);
      }
    },  
    watch : {
      'getChallengeSelected' : function (){
        this.getData();
        this.hide = false;
      },
      getIsMobile(){
        this.isMobile = this.getIsMobile;
      }
    },       
};
</script>
